





import { Component, Mixins } from 'vue-property-decorator';
import { Editor as TipTapEditor, EditorContent } from '@tiptap/vue-2';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import Strike from '@tiptap/extension-strike';
import Underline from '@tiptap/extension-underline';
import Text from '@tiptap/extension-text';
import { ProsemirrorViewerRoot } from '@/editor/editor-block-view/components/mixins/prosemirror-viewer-root';
import {
  ParagraphNode,
  BulletListNode,
  OrderedListNode,
  NoHeadingDocNode,
  NoHeadingListItemNode,
  MergeValueNode,
  HardBreakNode,
} from '@lib-shared/editor/tiptap/nodes';

@Component({
  components: {
    EditorContent,
  },
})
export default class PricingTableDescriptionInput extends Mixins(ProsemirrorViewerRoot) {
  viewer: TipTapEditor | null = null;

  get inputViewer() {
    return {
      content: this.content,
      enableInputRules: false,
      enablePasteRules: false,
      editable: false,
      extensions: [
        NoHeadingDocNode,
        ParagraphNode,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        OrderedListNode,
        BulletListNode,
        NoHeadingListItemNode,
        Link.configure({
          autolink: false,
          openOnClick: true,
          linkOnPaste: false,
        }),
        MergeValueNode,
        HardBreakNode,
      ],
      onCreate: this.handleInit,
    };
  }

  mounted() {
    this.viewer = new TipTapEditor(this.inputViewer);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
